module.exports = __webpack_public_path__ + "img/public_resources_smallmode_white.461cc3f4.svg";